module.exports = "<div class=\"container-fluid\">\n    <div class=\"row text-post-row\">\n        <div class=\"col-xs-12 col-md-offset-1 col-md-5  title-block\">\n            <h1 class=\"title\">{{( document | meta ).title}}</h1>\n            <p class=\"subtitle\">Home to Our Vibrant HD Video Channels</p>\n        </div>\n\n        <div class=\"col-xs-12 col-md-5\">\n            <p>{{( document | meta ).stripped_description}}</p>\n        </div>\n        <div class=\"col-md-1\"></div>\n    </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/angular-framework-client-components/components/text-post/text-post.template.html
// module id = 797
// module chunks = 2